import { render, staticRenderFns } from "./confirm-message.vue?vue&type=template&id=0aa2f842"
import script from "./confirm-message.vue?vue&type=script&lang=js"
export * from "./confirm-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports